import React from 'react';
import UsageDashboardHeader from './UsageDashboardHeader';
import AccountView from './AccountView/AccountView';
import { Layout } from 'antd';
import MetricsPanel from './MetricsPanel/MetricsPanel';
import { useGetCustomerList } from './hooks/dataFetcherhooks';
import './styles.css';

const { Sider, Content } = Layout;

const UsageDashboard = () => {
  const customerList = useGetCustomerList({ enabled: true });

  return (
    <Layout className="layoutStyle">
      <Sider className="siderStyle">
        <AccountView isCustomerListFetching={customerList.isFetching}></AccountView>
      </Sider>
      <Layout>
        <div className="headerStyle">
          <UsageDashboardHeader></UsageDashboardHeader>
        </div>
        <Content className="contentStyle">
          <MetricsPanel isCustomerListFetching={customerList.isFetching}></MetricsPanel>
        </Content>
      </Layout>
    </Layout>
  );
};

export default UsageDashboard;
